<template>
    <div class="approval-single-login">
    </div>
</template>

<script>
import api from '@/constants/api'
import utils from "@/constants/utils";
import common from "@/view/common.js"
import {aes_decrypt, getKey} from '@/tools/myEncrypt'
export default {
    data() {
        return {
            utils,
        }
    },
    methods: {
        // 根据手机号查询被访人
        async getInterviewee() {
            try {
                // 先获取密钥
                const keyInfo = await getKey()
                if (!keyInfo) {
                    this.$toast('获取密钥失败，请重试')
                    return
                }
                // 再获取业务数据（传入时间戳）
                let res = await api.getIntervieweeNameByPhone(this.phone, keyInfo.visitorstampKey);
                console.log('res333ddd', res);
                if (res.success) {
                    // 最后解密
                    const decryptData = await aes_decrypt(res.data, keyInfo)
                    if (!decryptData) {
                        this.$toast('解密失败，请重试')
                        return
                    }
                    res.data = decryptData
                    localStorage.setItem('myVisitorListActive', 0)
                    localStorage.setItem('logJumpVisitorList', JSON.stringify(true))
                    localStorage.setItem('v_personid', res.data.id)
                    sessionStorage.setItem('u_name', res.data.name)
                    sessionStorage.setItem('u_phone', this.phone)
                    localStorage.setItem('userId', '')
                    this.$router.push(`/approvalManage/${res.data.id}`)
                }
            } catch (error) {
                console.log(error)
            }
        },
        // async getInterviewee() {
        //     try {
        //         let res = await api.getIntervieweeNameByPhone(this.phone);
        //         if (res.success) {
        //             this.personId = res.data.id
        //             this.personName = res.data.name
        //             localStorage.setItem('myVisitorListActive', 0)
        //             this.$router.push(`/myVisitorList/${this.personId}`)
        //         }
        //     } catch (error) {
        //         console.log(error)
        //     }
        //     localStorage.setItem('v_personid', this.personId)
        //     sessionStorage.setItem('u_name', this.personName)
        // }
    },
    mounted() {
        let curHref = window.location.href;
        let hrefParam = common.getUrlParams(curHref)
        this.phone = hrefParam.phone
        console.log('页面地址和参数', curHref, hrefParam);
        if(!canJump) {
            return
        }
        if(hrefParam.visitorMode) {
            localStorage.setItem('visitorMode', Number(hrefParam.visitorMode))
        }
        // 老师进来一定有手机号，学生进来不一定有手机号
        if(this.phone) {
            this.getInterviewee();
            localStorage.setItem('u_phone', this.phone)
            return
        }
        // 学生没有手机号的情况，但一定有personId
        if(hrefParam.personId) {
            localStorage.setItem('myVisitorListActive', 0)
            localStorage.setItem('logJumpVisitorList', JSON.stringify(true))
            localStorage.setItem('v_personid', Number(hrefParam.personId))
            sessionStorage.setItem('u_name', hrefParam.personName ? decodeURI(hrefParam.personName) : '')
            localStorage.setItem('userId', '')
            this.$router.push(`/approvalManage/${hrefParam.personId}`)
            return
        }
        // 其他情况走下面
            // 跳转到登录页面
            this.$router.push({name: 'index'});
            localStorage.setItem('myVisitorListActive', 0)
            localStorage.setItem('u_phone', '')
            localStorage.setItem('v_personid', '')
            sessionStorage.setItem('u_name', '')
    }
}
</script>
<style lang="less">
</style>
